import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getAppSettings } from '../redux/actions/settings';

const keys = {
  videoAspectRatio: 'clips.allowed.video.aspect.ratio',
  videoFormat: 'clips.allowed.video.format',
  videoResolution: 'clips.allowed.video.resolution',
  categories: 'clips.categories',
  videoMinDuration: 'clips.min.video.duration.millisecond',
  videoMaxDuration: 'clips.max.video.duration.millisecond',
  videoMaxSize: 'clips.max.video.size.mb',
  thumbnailSize: 'clips.max.thumbnail.size.bytes',
  thumbnailResolution: 'clips.allowed.thumbnail.resolution',
  thumbnailAspectRatio: 'clips.allowed.thumbnail.aspect.ratio',
  reportReason: 'userReport.reason.content',
  commentReason: 'userReport.reason.comment',
  blockerAccessContentTitle: 'blocker.access_content.error_dialog.title',
  blockerAccessContentMessage: 'blocker.access_content.error_dialog.message',
  blockerFollowProfileTitle: 'blocker.follow_profile.error_dialog.title',
  blockerFollowProfileMessage: 'blocker.follow_profile.error_dialog.message',
  blockeeAccessContentTitle: 'blockee.access_content.error_dialog.title',
  blockeeAccessContentMessage: 'blockee.access_content.error_dialog.message',
  blockeeFollowProfileTitle: 'blockee.follow_profile.error_dialog.title',
  blockeeFollowProfileMessage: 'blockee.follow_profile.error_dialog.message',
  blockerUnblockDialogMessage: 'blocker.unblock_dialog.message',
  blockerUnblockDialogTitle: 'blocker.unblock_dialog.title',
};

const useSettings = () => {
  const dispatch = useDispatch();

  const { settings, loading, err } = useSelector((state) => state.appSettings);

  const clipsVideoMaxSize =
    settings?.[keys.videoMaxSize] && parseInt(settings[keys.videoMaxSize]);
  const clipsVideoFormat = settings?.[keys.videoFormat];
  const clipsVideoResolution = settings?.[keys.videoResolution];
  const clipsVideoAspectRatio = settings?.[keys.videoAspectRatio];
  const clipsVideoMinDuration = settings?.[keys.videoMinDuration];
  const clipsVideoMaxDuration = settings?.[keys.videoMaxDuration];
  const thumbnailMaxSize =
    settings?.[keys.thumbnailSize] && parseInt(settings[keys.thumbnailSize]);
  const thumbnailResolution = settings?.[keys.thumbnailResolution];
  const thumbnailAspectRatio = settings?.[keys.thumbnailAspectRatio];
  const dataClipsCategories = settings?.[keys.categories]?.split(',');

  //Settigs for Block and Report
  const reportReason = settings?.[keys.reportReason]?.split(',');
  const commentReason = settings?.[keys.commentReason]?.split(',');
  const blockerAccessContentTitle = settings?.[keys.blockerAccessContentTitle];
  const blockerAccessContentMessage =
    settings?.[keys.blockerAccessContentMessage];
  const blockerFollowProfileTitle = settings?.[keys.blockerFollowProfileTitle];
  const blockerFollowProfileMessage =
    settings?.[keys.blockerFollowProfileMessage];
  const blockeeAccessContentTitle = settings?.[keys.blockeeAccessContentTitle];
  const blockeeAccessContentMessage =
    settings?.[keys.blockeeAccessContentMessage];
  const blockeeFollowProfileTitle = settings?.[keys.blockeeFollowProfileTitle];
  const blockeeFollowProfileMessage =
    settings?.[keys.blockeeFollowProfileMessage];

  const blockerUnblockDialogMessage =
    settings?.[keys.blockerUnblockDialogMessage];
  const blockerUnblockDialogTitle = settings?.[keys.blockerUnblockDialogTitle];

  useEffect(() => {
    dispatch(getAppSettings());
  }, [dispatch]);

  return {
    settingsLoading: loading,
    settingsError: err,
    clipsVideoMaxSize,
    clipsVideoFormat,
    clipsVideoResolution,
    clipsVideoAspectRatio,
    clipsVideoMinDuration,
    clipsVideoMaxDuration,
    thumbnailMaxSize,
    thumbnailResolution,
    thumbnailAspectRatio,
    dataClipsCategories,
    reportReason,
    commentReason,
    blockerAccessContentTitle,
    blockerAccessContentMessage,
    blockerFollowProfileTitle,
    blockerFollowProfileMessage,
    blockeeAccessContentTitle,
    blockeeAccessContentMessage,
    blockeeFollowProfileTitle,
    blockeeFollowProfileMessage,
    blockerUnblockDialogMessage,
    blockerUnblockDialogTitle,
  };
};

export default useSettings;
